import { ChangeDetectionStrategy, Component, computed, inject, output, signal } from '@angular/core';
import { SlicePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { materialModules } from './../../../core/constants/mat-modules';

import { BranchStore } from '../../../core/interfaces';
import { PortalDataService } from '../portal-data.service';
import { MODALITIES_ICONS, Modality } from './opening-hours-complements';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'madero-opening-hours',
    templateUrl: './opening-hours.component.html',
    styleUrl: './opening-hours.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [...materialModules, SlicePipe, FormsModule, TranslatePipe],
})
export class OpeningHoursComponent {
  readonly branchModalities = inject(PortalDataService).branchModalities;

  return = output<void>();

  weekDay = signal<number | null>(null);

  branchModalitiesByWeekDay = computed<Modality[]>(() => {
    const weekDay = this.weekDay();

    if (weekDay === null) return [];

    return (
      this.branchModalities()?.map((m) => ({
        icon: MODALITIES_ICONS[m.modality.tag] || 'fastfood',
        name: m.modality.name,
        initialTime: m.openingHours.find((o) => o.dayWeek === weekDay)!.initialTime,
        endTime: m.openingHours.find((o) => o.dayWeek === weekDay)!.endTime,
      })) || []
    );
  });
  store = signal<BranchStore | null>(null);

  readonly weekDays = [
    { dayOfWeek: 0, label: 'PORTAL.OPENING_HOURS.SUNDAY' },
    { dayOfWeek: 1, label: 'PORTAL.OPENING_HOURS.MONDAY' },
    { dayOfWeek: 2, label: 'PORTAL.OPENING_HOURS.TUESDAY' },
    { dayOfWeek: 3, label: 'PORTAL.OPENING_HOURS.WEDNESDAY' },
    { dayOfWeek: 4, label: 'PORTAL.OPENING_HOURS.THURSDAY' },
    { dayOfWeek: 5, label: 'PORTAL.OPENING_HOURS.FRIDAY' },
    { dayOfWeek: 6, label: 'PORTAL.OPENING_HOURS.SATURDAY' },
  ];
}
